import icon_shield from '../../assets/icon-shield.svg';
import './style.scss';
import useElysiaStore from '@/app/elysia-store';

const SystemProtectionMessage = () => {
  const isChatActive = useElysiaStore((state) => state.isChatActive);
  const starterPrompts = useElysiaStore((state) => state.starterPrompts);
  return (
    <div
      className={`sys-msg-body sys-protection-msg ${!isChatActive && starterPrompts?.filter((prompts) => prompts !== '').length <= 1 ? 'sys-protection-alignment' : ''}`}
    >
      <img className="sys-msg-card-img" src={icon_shield} alt="icon" />
      <span className="sys-msg-card-title">
        {' '}
        Your personal and company data are protected in this chat{' '}
      </span>
    </div>
  );
};

export default SystemProtectionMessage;
